module.exports = __webpack_public_path__ + "img/can.dbfc1cb3.png";